<template>
  <div class="booking-mp">
    <div class="page-title">{{ $t("lang.openingTime") }}</div>
    <div v-if="recommendtimes.length > 0" class="open-recommend">
      <span v-if="language !== 'en'">有<span style="color:#F5A623;font-weight:bold;">{{ recommendtimes.length }}</span>个时间未安排老师，开放时间<span class="book-recommend" @click="addAllRecommend">立即抢单</span></span>
    </div>
    <div class="horizontal-container">
      <div class="scroll-wrapper" ref="scroll">
        <div class="scroll-content">
          <div class="scroll-item"
            v-for="(item, index) in timeTabs"
            :key="index"
            :class="{ tabActive: index === activedTab }"
            @click="handleTabClick(index)"
          >
            {{ item.format("MM-DD") }}<br>{{ language === 'en' ? item.locale("en").format("ddd") : item.locale("zh-cn").format("ddd") }}
          </div>
        </div>
      </div>
    </div>
    <div class="card booking-card">
      <div class="time-display">
        <!-- <div class="local-time">{{ $t("lang.localTime") }}<span class="time">{{ localTime }}</span></div>
        <div class="bj-time">{{ $t("lang.BeijingTime") }}<span class="time">{{ beijingTime }}</span></div> -->
        {{$t('lang.bookPage6')}}: {{timeZone}}
        <button @click="handleTZClick" class="wrong-timezone">{{$t('lang.wrongTimezone')}}<i class="el-icon-question"></i></button>
      </div>
      <div v-for="i in 14" :key="i">
        <div v-if="activedTab + 1 === i" style="display: flex; flex-direction: column;">
          <div class="period-1">
            <div class="time-tag">{{ $t("lang.morning") }}</div>
            <div class="period-box">
              <div class="select-btn" v-for="period in morningPeriod" :key="period.id">
                <div v-if="period[`expired${i}`]" class="expired">
                  <div v-if="period[`selected${i}`]" class="expired-unScheduled">
                    <span>{{ period.text }}</span>
                    <span>{{$t('lang.homePage27')}}</span>
                  </div>
                  <div v-else-if="period[`booked${i}`]" class="expired-booked">
                    <span>{{ period[`booked${i}`].time.split(' ')[0] || period.text }}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 1">{{$t('lang.classeBegin')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 2">{{$t('lang.homePage28')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 3">{{$t('lang.homePage29')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 4">{{$t('lang.homePage30')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 5">{{$t('lang.homePage31')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 6">{{$t('lang.homePage32')}}</span>
                  </div>
                  <div v-else>{{ period.text }}</div>
                </div>
                <div v-else class="defalut">
                  <div v-if="period[`selected${i}`]" class="selected" @click="cancelTimes(period[`addAvailableDay${i}`], period[`addAvailableTime${i}`])">
                    <i class="el-icon-circle-check"></i>{{ period.text }}
                  </div>
                  <div v-else-if="period[`booked${i}`]" class="booked">
                    <span>{{ period[`booked${i}`].time.split(' ')[0] || period.text }}</span>
                    <span v-if="period[`booked${i}`].courseType === 0">{{$t('lang.ordered1v1')}}</span>
                    <span v-if="period[`booked${i}`].courseType === 1">{{$t('lang.orderedOpen')}}</span>
                    <span v-if="period[`booked${i}`].courseType === 2">{{$t('lang.ordered1vN')}}</span>
                  </div>
                  <div class="unbooked" v-else @click="addTime(period[`addAvailableDay${i}`], period[`addAvailableTime${i}`])">
                    <span v-if="period[`recommend${i}`]" class="recommend">
                      <span>{{ period.text }}</span>
                      <span>{{$t('lang.recommendTip')}}</span>
                    </span>
                    <span v-else>{{ period.text }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="period-2">
            <div class="time-tag">{{ $t("lang.afternoon") }}</div>
            <div class="period-box">
              <div class="select-btn" v-for="period in afternoonPeriod" :key="period.id">
                <div v-if="period[`expired${i}`]" class="expired">
                  <div v-if="period[`selected${i}`]" class="expired-unScheduled">
                    <span>{{ period.text }}</span>
                    <span>{{$t('lang.homePage27')}}</span>
                  </div>
                  <div v-else-if="period[`booked${i}`]" class="expired-booked">
                    <span>{{ period.text }}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 1">{{$t('lang.classeBegin')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 2">{{$t('lang.homePage28')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 3">{{$t('lang.homePage29')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 4">{{$t('lang.homePage30')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 5">{{$t('lang.homePage31')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 6">{{$t('lang.homePage32')}}</span>
                  </div>
                  <div v-else>{{ period.text }}</div>
                </div>
                <div v-else class="defalut">
                  <div v-if="period[`selected${i}`]" class="selected" @click="cancelTimes(period[`addAvailableDay${i}`], period[`addAvailableTime${i}`])">
                    <i class="el-icon-circle-check"></i>{{ period.text }}
                  </div>
                  <div v-else-if="period[`booked${i}`]" class="booked">
                    <span>{{ period.text }}</span>
                    <span v-if="period[`booked${i}`].courseType === 0">{{$t('lang.ordered1v1')}}</span>
                    <span v-if="period[`booked${i}`].courseType === 1">{{$t('lang.orderedOpen')}}</span>
                    <span v-if="period[`booked${i}`].courseType === 2">{{$t('lang.ordered1vN')}}</span>
                  </div>
                  <div class="unbooked" v-else @click="addTime(period[`addAvailableDay${i}`], period[`addAvailableTime${i}`])">
                    <span v-if="period[`recommend${i}`]" class="recommend">
                      <span>{{ period.text }}</span>
                      <span>{{$t('lang.recommendTip')}}</span>
                    </span>
                    <span v-else>{{ period.text }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="period-3">
            <div class="time-tag">{{ $t("lang.night") }}</div>
            <div class="period-box">
              <div class="select-btn" v-for="period in nightPeriod" :key="period.id">
                <div v-if="period[`expired${i}`]" class="expired">
                  <div v-if="period[`selected${i}`]" class="expired-unScheduled">
                    <span>{{ period.text }}</span>
                    <span>{{$t('lang.homePage27')}}</span>
                  </div>
                  <div v-else-if="period[`booked${i}`]" class="expired-booked">
                    <span>{{ period.text }}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 1">{{$t('lang.classeBegin')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 2">{{$t('lang.homePage28')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 3">{{$t('lang.homePage29')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 4">{{$t('lang.homePage30')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 5">{{$t('lang.homePage31')}}</span>
                    <span v-if="period[`booked${i}`].lessonStatus === 6">{{$t('lang.homePage32')}}</span>
                  </div>
                  <div v-else>{{ period.text }}</div>
                </div>
                <div v-else class="defalut">
                  <div v-if="period[`selected${i}`]" class="selected" @click="cancelTimes(period[`addAvailableDay${i}`], period[`addAvailableTime${i}`])">
                    <i class="el-icon-circle-check"></i>{{ period.text }}
                  </div>
                  <div v-else-if="period[`booked${i}`]" class="booked">
                    <span>{{ period.text }}</span>
                    <span v-if="period[`booked${i}`].courseType === 0">{{$t('lang.ordered1v1')}}</span>
                    <span v-if="period[`booked${i}`].courseType === 1">{{$t('lang.orderedOpen')}}</span>
                    <span v-if="period[`booked${i}`].courseType === 2">{{$t('lang.ordered1vN')}}</span>
                  </div>
                  <div class="unbooked" v-else @click="addTime(period[`addAvailableDay${i}`], period[`addAvailableTime${i}`])">
                    <span v-if="period[`recommend${i}`]" class="recommend">
                      <span>{{ period.text }}</span>
                      <span>{{$t('lang.recommendTip')}}</span>
                    </span>
                    <span v-else>{{ period.text }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-group">
        <button class="select_all-btn" @click="addAllTimes(beijingDate)">
          {{$t('lang.allOpen')}}
        </button>
        <button class="cancel_all-btn" @click="cancelAllTimes(beijingDate)">
          {{$t('lang.cancelAll')}}
        </button>
      </div>
    </div>
    <el-dialog
      class="timzone-dialog"
      :show-close="false"
      :center="true"
      :width="'86vw'"
      :top="'25vh'"
      :visible.sync="timezoneDialogVisible"
    >
      <div class="tip">{{ $t("lang.selectTZ") }}</div>
      <label class="tz-label" for="tz">UTC：</label>
      <select class="tz-select" style="width: 100%" v-model="tz" name="tz" id="tz">
        <option disabled value="">{{ $t("lang.select") }}</option>
        <option v-for="(tz, index) in timeZones" :key="index" :label="tz.text" :value="tz.utc">{{ tz.text }}</option>
      </select>
      <label class="tz-label" for="tz">{{ $t("lang.TZ") }}：</label>
      <select class="tz-select" style="width: 100%" v-model="tzId" name="tzId" id="tzId">
        <option disabled value="">{{ $t("lang.select") }}</option>
        <option v-for="(tz, index) in tz" :key="index" :label="tz" :value="tz">{{ tz }}</option>
      </select>
      <span slot="footer" class="dialog-footer">
        <el-button class="quit-btn" @click="timezoneDialogVisible = false">{{ $t("lang.cancel") }}</el-button>
        <el-button class="unbinding-btn" @click="setTimezone">{{ $t("lang.confirm") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ERR_OK, TIME_ZONE } from "api/config";
import moment from "moment-timezone";
import {
  getlessonsHomePage,
  saveAvailableTimes,
  addTempAvailableTime,
  cancelTempAvailableTime,
  updateAvailableTimes,
  getNeedAvailableTimeList,
  addAvailableTimeBatch
} from "api/course";
import _ from "lodash";
import { mapGetters } from "vuex";
import { updateUserInfo } from "api/me";
import BScroll from 'better-scroll'
import timezones from "utils/timezones"

export default {
  data () {
    return {
      timeZone: localStorage.getItem('timeZone') ? localStorage.getItem('timeZone') : 'Asia/Shanghai',
      timezoneDialogVisible: false,
      timeZones: timezones,
      tz: '',
      tzId: '',
      bs: null,
      listQuery: {
        startWeek: "",
        endWeek: ""
      },
      timeTabs: [],
      lessonInfos: [],
      unScheduled: [],
      tempAvailableTime: [],
      cancelIds: [],
      tempIds: [],
      cancelTempIds: [],
      recommendtimes: [],
      activedTab: 0,
      beijingTabData: [
        {
          text: "08:00",
          time: "08:00:00",
          id: 1
        },
        {
          text: "08:30",
          time: "08:30:00",
          id: 2
        },
        {
          text: "09:00",
          time: "09:00:00",
          id: 3
        },
        {
          text: "09:30",
          time: "09:30:00",
          id: 4
        },
        {
          text: "10:00",
          time: "10:00:00",
          id: 5
        },
        {
          text: "10:30",
          time: "10:30:00",
          id: 6
        },
        {
          text: "11:00",
          time: "11:00:00",
          id: 7
        },
        {
          text: "11:30",
          time: "11:30:00",
          id: 8
        },
        {
          text: "12:00",
          time: "12:00:00",
          id: 9
        },
        {
          text: "12:30",
          time: "12:30:00",
          id: 10
        },
        {
          text: "13:00",
          time: "13:00:00",
          id: 11
        },
        {
          text: "13:30",
          time: "13:30:00",
          id: 12
        },
        {
          text: "14:00",
          time: "14:00:00",
          id: 13
        },
        {
          text: "14:30",
          time: "14:30:00",
          id: 14
        },
        {
          text: "15:00",
          time: "15:00:00",
          id: 15
        },
        {
          text: "15:30",
          time: "15:30:00",
          id: 16
        },
        {
          text: "16:00",
          time: "16:00:00",
          id: 17
        },
        {
          text: "16:30",
          time: "16:30:00",
          id: 18
        },
        {
          text: "17:00",
          time: "17:00:00",
          id: 19
        },
        {
          text: "17:30",
          time: "17:30:00",
          id: 20
        },
        {
          text: "18:00",
          time: "18:00:00",
          id: 21
        },
        {
          text: "18:30",
          time: "18:30:00",
          id: 22
        },
        {
          text: "19:00",
          time: "19:00:00",
          id: 23
        },
        {
          text: "19:30",
          time: "19:30:00",
          id: 24
        },
        {
          text: "20:00",
          time: "20:00:00",
          id: 25
        },
        {
          text: "20:30",
          time: "20:30:00",
          id: 26
        }
      ],
      tableData: [
        {
          text: "12:00",
          time: "00:00:00",
          id: 1
        },
        {
          text: "12:30",
          time: "00:30:00",
          id: 2
        },
        {
          text: "01:00",
          time: "01:00:00",
          id: 3
        },
        {
          text: "01:30",
          time: "01:30:00",
          id: 4
        },
        {
          text: "02:00",
          time: "02:00:00",
          id: 5
        },
        {
          text: "02:30",
          time: "02:30:00",
          id: 6
        },
        {
          text: "03:00",
          time: "03:00:00",
          id: 7
        },
        {
          text: "03:30",
          time: "03:30:00",
          id: 8
        },
        {
          text: "04:00",
          time: "04:00:00",
          id: 9
        },
        {
          text: "04:30",
          time: "04:30:00",
          id: 10
        },
        {
          text: "05:00",
          time: "05:00:00",
          id: 11
        },
        {
          text: "05:30",
          time: "05:30:00",
          id: 12
        },
        {
          text: "06:00",
          time: "06:00:00",
          id: 13
        },
        {
          text: "06:30",
          time: "06:30:00",
          id: 14
        },
        {
          text: "07:00",
          time: "07:00:00",
          id: 15
        },
        {
          text: "07:30",
          time: "07:30:00",
          id: 16
        },
        {
          text: "07:00",
          time: "19:00:00",
          id: 17
        },
        {
          text: "07:30",
          time: "19:30:00",
          id: 18
        },
        {
          text: "08:00",
          time: "20:00:00",
          id: 19
        },
        {
          text: "08:30",
          time: "20:30:00",
          id: 20
        },
        {
          text: "09:00",
          time: "21:00:00",
          id: 21
        },
        {
          text: "09:30",
          time: "21:30:00",
          id: 22
        },
        {
          text: "10:00",
          time: "22:00:00",
          id: 23
        },
        {
          text: "10:30",
          time: "22:30:00",
          id: 24
        },
        {
          text: "11:00",
          time: "23:00:00",
          id: 25
        },
        {
          text: "11:30",
          time: "23:30:00",
          id: 26
        }
      ],
      beijingTimeData: [
        '08:00:00',
        '08:30:00',
        '09:00:00',
        '09:30:00',
        '10:00:00',
        '10:30:00',
        '11:00:00',
        '11:30:00',
        '12:00:00',
        '12:30:00',
        '13:00:00',
        '13:30:00',
        '14:00:00',
        '14:30:00',
        '15:00:00',
        '15:30:00',
        '16:00:00',
        '16:30:00',
        '17:00:00',
        '17:30:00',
        '18:00:00',
        '18:30:00',
        '19:00:00',
        '19:30:00',
        '20:00:00',
        '20:30:00'
      ]
    }
  },
  created () {
    this.getTimeZone()
    // alert(this.timeZone);
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.bs.destroy()
  },
  computed: {
    ...mapGetters(["language", "timezone", "id"]),
    localTime() {
      return this.timeTabs[this.activedTab].format("YYYY-MM-DD ddd")
    },
    beijingTime() {
      return this.timeTabs[this.activedTab].tz('Asia/Shanghai').format("YYYY-MM-DD ddd")
    },
    beijingDate() {
      return this.timeTabs[this.activedTab].tz('Asia/Shanghai').format("YYYY-MM-DD")
    },
    morningPeriod() {
      return this.tableData.slice(0, 8)
    },
    afternoonPeriod() {
      return this.tableData.slice(8, 18)
    },
    nightPeriod() {
      return this.tableData.slice(18)
    }
  },
  methods: {
    handleTZClick() {
      this.timezoneDialogVisible = true
    },
    setTimezone() {
      if (this.tzId && this.tz) {
        let newTzId = this.tzId
        this.timeZone = newTzId
        updateUserInfo({timezone: newTzId})
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              localStorage.setItem('timeZone', newTzId)
              location.reload()
              // this.getTimeZone()
              // this.resetData()
              // this._getlessonsHomePage(1);
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
        this.timezoneDialogVisible = false
      } else {
        this.$message.error(this.$t('lang.tzNullTip'));
      }
    },
    handleTabClick(id) {
      this.activedTab = id
    },
    init() {
      this.bs = new BScroll(this.$refs.scroll, {
        scrollX: true,
        probeType: 3, // listening scroll hook
        click: true
      })
      this._registerHooks(['scroll', 'scrollEnd'], (pos) => {
        console.log('done')
      })
    },
    _registerHooks(hookNames, handler) {
      hookNames.forEach((name) => {
        this.bs.on(name, handler)
      })
    },
    getTimeZone() {
      if (TIME_ZONE.indexOf(this.timeZone) > -1) {
        alert("No time zone");
      } else {
        moment.tz.setDefault(this.timeZone);
        this.getTimeTabs();
      }
    },
    getTimeTabs() {
      const _timeTabs = []
      for (let i = 0; i < 14; i++) {
        let day = moment()
          .tz(this.timeZone)
          .add(i, "days")
          // .format("YYYY-MM-DD");
        _timeTabs.push(day);
      }
      this.timeTabs = _timeTabs
      this.listQuery.startWeek = this.formatBeijingYYYYMMDDHHmmss(
        `${this.timeTabs[0].format("YYYY-MM-DD")} 00:00`
      );
      this.listQuery.endWeek = this.formatBeijingYYYYMMDDHHmmss(
        `${this.timeTabs[13].format("YYYY-MM-DD")} 23:59`
      );
      this._getlessonsHomePage(1);
    },
    makelocalTimeTableDate() {
      let day = moment()
        // .add(this.listQuery.week, "weeks")
        .startOf("date")
        .format("YYYY-MM-DD");
      for (let i = 0; i < this.beijingTabData.length; i++) {
        this.tableData[i].time = moment
          .tz(`${day} ${this.beijingTabData[i]["time"]}`, "Asia/Shanghai")
          .tz(this.timeZone)
          .format("HH:mm:ss");
        var order =
          moment
            .tz(`${day} ${this.tableData[i]["time"]}`, this.timeZone)
            .hours() *
            60 +
          moment
            .tz(`${day} ${this.tableData[i]["time"]}`, this.timeZone)
            .minutes();
        this.tableData[i].text = moment
          .tz(`${day} ${this.beijingTabData[i]["time"]}`, "Asia/Shanghai")
          .tz(this.timeZone)
          .format("HH:mm");
        this.$set(this.tableData[i], `order`, order);
      }
      // console.log(this.tableData)
    },
    formTableData() {
      var now = moment().unix();
      for (var i = 1; i < 15; i++) {
        var day = moment()
          .tz(this.timeZone)
          .startOf("date")
          .add(i - 1, "days")
          .format("YYYY-MM-DD");
        for (var j = 0; j < this.tableData.length; j++) {
          var targetTime = moment(day + " " + this.tableData[j]["time"]).unix();
          var beijinghotStart = moment(day + " 18:59:00 +800").unix();
          var beijinghotEnd = moment(day + " 20:31:00 +800").unix();
          if (targetTime > beijinghotStart && targetTime < beijinghotEnd) {
            this.$set(this.tableData[j], `hot${i}`, true);
            this.$set(this.tableData[j], `hot0`, true);
          }
          var NightStart = moment(day + " 11:59:00").unix();
          var NightEnd = moment(day + " 23:59:00").unix();
          if (targetTime > NightStart && targetTime < NightEnd) {
            this.$set(this.tableData[j], `night0`, true);
          }
          if (now > targetTime) {
            this.$set(this.tableData[j], `expired${i}`, true);
          }

          this.$set(this.tableData[j], `localDay${i}`, day);
          this.$set(
            this.tableData[j],
            `localTime${i}`,
            this.tableData[j]["text"]
          );
          this.$set(
            this.tableData[j],
            `addAvailableDay${i}`,
            this.formatBeijingYYYYMMDD(day + " " + this.tableData[j]["time"])
          );
          this.$set(
            this.tableData[j],
            `addAvailableTime${i}`,
            this.formatBeijingHHmmss(day + " " + this.tableData[j]["time"])
          );
          this.$set(
            this.tableData[j],
            `BeijingDay${i}`,
            this.formatBeijingYYYYMMDD(day + " " + this.tableData[j]["time"])
          );
          this.$set(
            this.tableData[j],
            `BeijingTime${i}`,
            this.formatBeijinghhmmA(day + " " + this.tableData[j]["time"])
          );
        }
      }
      this.tableData = _.sortBy(this.tableData, ["order"]);
    },
    formatLocalTimeYYYYMMDDHHmmss(s) {
      if (s) {
        return moment
          .tz(s, "Asia/Shanghai")
          .tz(this.timeZone)
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    formatBeijingYYYYMMDDHHmmss(s) {
      if (s) {
        return moment
          .tz(s, this.timeZone)
          .tz("Asia/Shanghai")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    formatBeijingYYYYMMDD(s) {
      if (s) {
        return moment
          .tz(s, this.timeZone)
          .tz("Asia/Shanghai")
          .format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    formatBeijinghhmmA(s) {
      if (s) {
        return moment
          .tz(s, this.timeZone)
          .tz("Asia/Shanghai")
          .format("hh:mm A");
      } else {
        return "";
      }
    },
    formatBeijingHHmmss(s) {
      if (s) {
        return moment
          .tz(s, this.timeZone)
          .tz("Asia/Shanghai")
          .format("HH:mm:ss");
      } else {
        return "";
      }
    },
    formatBeijingHHmm(s) {
      if (s) {
        return moment
          .tz(s, this.timeZone)
          .tz("Asia/Shanghai")
          .format("HH:mm");
      } else {
        return "";
      }
    },
    formTableDataRow(startHHmmss) {
      let formTableDataRowTime = [];
      for (let i = 0; i < this.tableData.length; i++) {
        formTableDataRowTime.push(this.tableData[i].time);
      }
      return formTableDataRowTime.indexOf(startHHmmss) + 1;
    },
    addTime(startDate, startTime) {
      let param = {
        date: startDate + ' 00:00:00',
        addTimes: startTime,
        timeZone: this.timeZone
      };
      updateAvailableTimes(param)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === 200) {
              let data = this.formatLocalTimeYYYYMMDDHHmmss(
                `${startDate} ${startTime}`
              );
              let day = moment().tz(this.timeZone).format("YYYY-MM-DD");
              let startYYYYMMDD = moment(data).format("YYYY-MM-DD")
              let startDay = moment(startYYYYMMDD).diff(moment(day), 'days')
              let startHHmmss = moment(data).format("HH:mm:ss");
              let row = this.formTableDataRow(startHHmmss);
              if (this.tableData[row - 1]) {
                this.$set(
                  this.tableData[row - 1],
                  `selected${startDay + 1}`,
                  true
                );
              }
              this.$message.success(this.$t('lang.addTime'));
              this.resetData()
              this._getlessonsHomePage(1);
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    cancelTimes(startDate, startTime) {
      let param = {
        date: startDate + ' 00:00:00',
        cancelTimes: startTime,
        timeZone: this.timeZone
      };
      updateAvailableTimes(param)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === 200) {
              let data = this.formatLocalTimeYYYYMMDDHHmmss(
                `${startDate} ${startTime}`
              );
              let day = moment().tz(this.timeZone).format("YYYY-MM-DD");
              let startYYYYMMDD = moment(data).format("YYYY-MM-DD")
              let startDay = moment(startYYYYMMDD).diff(moment(day), 'days')
              let startHHmmss = moment(data).format("HH:mm:ss");
              let row = this.formTableDataRow(startHHmmss);
              if (this.tableData[row - 1]) {
                this.$set(
                  this.tableData[row - 1],
                  `selected${startDay + 1}`,
                  false
                );
              }
              this.$message.success(this.$t('lang.cancelTime'));
              this.resetData()
              this._getlessonsHomePage(1);
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    addAllTimes(date) {
      let expiredIndex = 0
      let now = moment().unix()
      let timeData = this.beijingTimeData
      for (let i = 0; i < timeData.length; i++) {
        let unixTime = moment(date + ' ' + timeData[i]).unix()
        if (unixTime > now) {
          expiredIndex = timeData.indexOf(moment.unix(unixTime).format('HH:mm:ss'))
          break
        }
      }
      let slicedDate = timeData.slice(expiredIndex)
      let param = {
        date: date + ' 00:00:00',
        addTimes: slicedDate.toString(),
        timeZone: this.timeZone
      }
      updateAvailableTimes(param)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === 200) {
              this.$message.success(this.$t('lang.addTime'));
              this.resetData()
              this._getlessonsHomePage(1);
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    cancelAllTimes(date) {
      let expiredIndex = 0
      let now = moment().unix()
      let timeData = this.beijingTimeData
      for (let i = 0; i < timeData.length; i++) {
        let unixTime = moment(date + ' ' + timeData[i]).unix()
        if (unixTime > now) {
          expiredIndex = timeData.indexOf(moment.unix(unixTime).format('HH:mm:ss'))
          break
        }
      }
      let slicedDate = timeData.slice(expiredIndex)
      let param = {
        date: date + ' 00:00:00',
        cancelTimes: slicedDate.toString(),
        timeZone: this.timeZone
      }
      updateAvailableTimes(param)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === 200) {
              this.$message.success(this.$t('lang.cancelTime'));
              this.resetData()
              this._getlessonsHomePage(1);
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    addAllRecommend() {
      let param = {
        addTimes: this.recommendtimes.toString(),
        timeZone: this.timeZone
      };
      addAvailableTimeBatch(param)
        .then(response => {
          console.log(response)
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (+response.data.code === +ERR_OK) {
              this.$message.success(this.$t('lang.bookPage11'));
              this.resetData()
              this._getlessonsHomePage(1);
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    chooseTime(startDate, startTime) {
      let formData = {
        startDate,
        startTime
      };
      addTempAvailableTime(formData)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              let id = response.data.data.id;
              this.tempIds.push(id);
              let data = this.formatLocalTimeYYYYMMDDHHmmss(
                `${response.data.data.startDate} ${
                  response.data.data.startTime
                }`
              );
              let day = moment().tz(this.timeZone).format("YYYY-MM-DD");
              let startYYYYMMDD = moment(data).format("YYYY-MM-DD")
              let startDate = moment(startYYYYMMDD).diff(moment(day), 'days')
              let startHHmmss = moment(data).format("HH:mm:ss");
              let row = this.formTableDataRow(startHHmmss);
              if (this.tableData[row - 1]) {
                this.$set(
                  this.tableData[row - 1],
                  `selectedTemp${startDate + 1}`,
                  true
                );
                this.$set(
                  this.tableData[row - 1],
                  `selectedTempId${startDate + 1}`,
                  id
                );
                this.$set(
                  this.tableData[row - 1],
                  `selectedTempText${startDate}`,
                  moment(data).format("hh:mm A")
                );
              }
              this._saveAvailableTimes()
              // console.log(this.tableData)
              // this.$message.success(this.$t('lang.bookPage8'));
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    cancelTime(id) {
      let paramId = {
        id
      };
      this.cancelIds.push(id);
      cancelTempAvailableTime(paramId)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              let ids = id;
              this.tempIds.splice(
                this.tempIds.findIndex(item => item.id === ids),
                1
              );
              this._saveAvailableTimes()
              // this.$message.success(this.$t('lang.bookPage10'));
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _saveAvailableTimes() {
      let param = {
        tempIds: this.tempIds.toString(),
        cancelIds: this.cancelIds.toString(),
        week: 0,
        timeZone: this.timeZone
      };
      saveAvailableTimes(param)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.$message.success(this.$t('lang.bookPage11'));
              this.resetData()
              this._getlessonsHomePage(1);
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _getlessonsHomePage(flag) {
      let day = moment()
        .tz(this.timeZone)
        .format("YYYY-MM-DD");
      getlessonsHomePage(this.listQuery)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              if (flag === 1) {
                this.makelocalTimeTableDate();
                this.formTableData();
              }
              this.tempIds = [];
              this.lessonInfos = response.data.data.lessonInfos;
              for (let i = 0; i < this.lessonInfos.length; i++) {
                let data = this.lessonInfos[i];
                let dataTime = this.formatLocalTimeYYYYMMDDHHmmss(
                  this.lessonInfos[i].startTimeBase || this.lessonInfos[i].startTime
                );
                let dataTimeActual = this.formatLocalTimeYYYYMMDDHHmmss(
                  this.lessonInfos[i].startTime
                );
                let startYYYYMMDD = moment(dataTime).format("YYYY-MM-DD")
                let startDate = moment(startYYYYMMDD).diff(moment(day), 'days')
                let displayName = "";
                let age = "";
                if (data.stuSimpInfo[0]) {
                  displayName = this.language === 'cn' ? data.stuSimpInfo[0].childCnName : data.stuSimpInfo[0].childEnName;
                  age = data.stuSimpInfo[0].age;
                }
                let lessonInfo = {
                  displayName: displayName,
                  age: age,
                  level: data.courseName,
                  lesson: data.lessonName,
                  date: moment(dataTime).format("YYYY-MM-DD"),
                  time: moment(dataTimeActual).format("hh:mm A"),
                  id: data.id,
                  roomId: data.roomId,
                  courseType: data.trial ? 3 : data.courseType,
                  lessonStatus: data.lessonStatus
                };
                let startHHmmss = moment(dataTime).format("HH:mm:ss");
                let row = this.formTableDataRow(startHHmmss);
                if (this.tableData[row - 1]) {
                  this.$set(
                    this.tableData[row - 1],
                    `booked${startDate + 1}`,
                    lessonInfo
                  );
                }
              }
              this.unScheduled = response.data.data.unScheduled;
              for (let i = 0; i < this.unScheduled.length; i++) {
                let data = this.formatLocalTimeYYYYMMDDHHmmss(
                  `${this.unScheduled[i].startDate} ${
                    this.unScheduled[i].startTime
                  }`
                );
                let startYYYYMMDD = moment(data).format("YYYY-MM-DD")
                let startDate = moment(startYYYYMMDD).diff(moment(day), 'days')
                let startHHmmss = moment(data).format("HH:mm:ss");
                let row = this.formTableDataRow(startHHmmss);
                if (this.tableData[row - 1]) {
                  this.$set(
                    this.tableData[row - 1],
                    `selectedTemp${startDate + 1}`,
                    false
                  );
                  this.$set(
                    this.tableData[row - 1],
                    `selected${startDate + 1}`,
                    true
                  );
                  this.$set(
                    this.tableData[row - 1],
                    `selectedId${startDate + 1}`,
                    this.unScheduled[i].id
                  );
                  this.$set(
                    this.tableData[row - 1],
                    `selectedText${startDate + 1}`,
                    moment(data).format("hh:mm A")
                  );
                }
              }
              this.tempAvailableTime = response.data.data.tempAvailableTime;
              for (let i = 0; i < this.tempAvailableTime.length; i++) {
                let data = this.formatLocalTimeYYYYMMDDHHmmss(
                  `${this.tempAvailableTime[i].startDate} ${
                    this.tempAvailableTime[i].startTime
                  }`
                );
                let startDate = moment(data).days();
                if (startDate === 0) {
                  startDate = 7;
                }
                if (this.tempIds.indexOf(this.tempAvailableTime[i].id) === -1) {
                  this.tempIds.push(this.tempAvailableTime[i].id);
                }
                let startHHmmss = moment(data).format("HH:mm:ss");
                let row = this.formTableDataRow(startHHmmss);
                if (this.tableData[row - 1]) {
                  this.$set(
                    this.tableData[row - 1],
                    `selectedTemp${startDate + 1}`,
                    true
                  );
                  this.$set(
                    this.tableData[row - 1],
                    `selectedTempId${startDate + 1}`,
                    this.tempAvailableTime[i].id
                  );
                  this.$set(
                    this.tableData[row - 1],
                    `selectedTempText${startDate + 1}`,
                    moment(data).format("hh:mm A")
                  );
                }
              }
              getNeedAvailableTimeList({
                teacherId: this.id
              }).then(res => {
                if (+res.data.code === +ERR_OK) {
                  this.recommendtimes = []
                  if (!res.data.data) {
                    return
                  }
                  for (let i = 0; i < res.data.data.length; i++) {
                    let timeunix = res.data.data[i]
                    let startDate = moment(timeunix).diff(moment(day), 'days')
                    this.recommendtimes.push(timeunix)
                    let startHHmmss = moment(timeunix).format("HH:mm:ss");
                    let row = this.formTableDataRow(startHHmmss);
                    if (this.tableData[row - 1]) {
                      this.$set(
                        this.tableData[row - 1],
                        `recommend${startDate + 1}`,
                        true
                      );
                    }
                  }
                }
              })
              console.log(this.tableData)
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    resetData() {
      this.tableData = [
        {
          text: "",
          time: "00:00:00",
          id: 1
        },
        {
          text: "",
          time: "00:30:00",
          id: 2
        },
        {
          text: "",
          time: "01:00:00",
          id: 3
        },
        {
          text: "",
          time: "01:30:00",
          id: 4
        },
        {
          text: "",
          time: "02:00:00",
          id: 5
        },
        {
          text: "",
          time: "02:30:00",
          id: 6
        },
        {
          text: "",
          time: "03:00:00",
          id: 7
        },
        {
          text: "",
          time: "03:30:00",
          id: 8
        },
        {
          text: "",
          time: "04:00:00",
          id: 9
        },
        {
          text: "",
          time: "04:30:00",
          id: 10
        },
        {
          text: "",
          time: "05:00:00",
          id: 11
        },
        {
          text: "",
          time: "05:30:00",
          id: 12
        },
        {
          text: "",
          time: "06:00:00",
          id: 13
        },
        {
          text: "",
          time: "06:30:00",
          id: 14
        },
        {
          text: "",
          time: "07:00:00",
          id: 15
        },
        {
          text: "",
          time: "07:30:00",
          id: 16
        },
        {
          text: "",
          time: "19:00:00",
          id: 17
        },
        {
          text: "",
          time: "19:30:00",
          id: 18
        },
        {
          text: "",
          time: "20:00:00",
          id: 19
        },
        {
          text: "",
          time: "20:30:00",
          id: 20
        },
        {
          text: "",
          time: "21:00:00",
          id: 21
        },
        {
          text: "",
          time: "21:30:00",
          id: 22
        },
        {
          text: "",
          time: "22:00:00",
          id: 23
        },
        {
          text: "",
          time: "22:30:00",
          id: 24
        },
        {
          text: "",
          time: "23:00:00",
          id: 25
        },
        {
          text: "",
          time: "23:30:00",
          id: 26
        }
      ];
    }
  }
}
</script>

<style lang="scss">
.booking-mp {
  display: flex;
  flex-direction: column;
  max-width: 750px;
  padding: 0 4vw;
  height: 100vh;
  margin: 0 auto;
  font-size: 15px;
  color: #000000;
  background: #f9f9f9;

  .card {
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    padding: 10px;
    font-size: 15px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
  }

  .page-title {
    margin: 18px 0 0;
    font-weight: 500;
  }

  .open-recommend {
    margin: 10px 0 0;
  }

  .book-recommend {
    color: #F5A623;
    font-weight: bold;
    text-decoration: underline;
  }

  .scroll-wrapper {
    width: 100%;
    margin: 20px 0 10px;
    white-space: nowrap;
    border-radius: 5px;
    overflow: hidden;
  }

  .scroll-content {
    // width: 100%;
    display: inline-block;

    .scroll-item{
      width: 66px;
      height: 34px;
      padding: 4px 0;
      line-height: 16px;
      font-size: 14px;
      color: #303133;
      border-radius: 5px;
      background: #ffffff;
      display: inline-block;
      text-align: center;
      margin: 0 6px;

      &:nth-child(1) {
        margin-left: 0;
      }
    }
  }

  .tabActive {
    background: #FFDD02 !important;
    color: #303133 !important;
    font-weight: 500;
  }

  .time-display {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #303133;

    .time {
      color: #303133;
    }
  }

  .time-tag {
    margin: 20px 0 10px;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
  }

  .period-box {
    display: grid;
    grid-template-columns: repeat(4, 68px);
    justify-content: space-between;
    .select-btn {
      margin-bottom: 10px;
      padding: 0;
      height: 36px;
      background: #EBEBEB;
      border: none;
      font-size: 12;
      color: #303133;
    }

    span {
      text-align: center;
    }
  }

  .expired {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: #EBEBEB;
    // background: #9B9B9B;
  }

  .expired-unScheduled {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    font-weight: 500;
    width: 100%;
    height: 100%;
  }

  .defalut {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .selected {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #F5A623;
    font-weight: 500;
    border: 1px solid #F5A623;
    background: #ffffff;

    .el-icon-circle-check {
      font-size: 15px;
      margin-right: 2px;
    }
  }

  .booked {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: #FFDD02;
    font-size: 10px;
    font-weight: 500;
  }

  .recommend {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    color: #F5A623;
    background: #FFFFFF;
    font-size: 10px;
    font-weight: 500;
  }

  .unbooked {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    background: #ffffff;
    border: 1px solid #cfcfcf;
  }

  .expired-booked {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    font-size: 10px;
    font-weight: 500;
  }

  .btn-group {
    display: flex;
    justify-content: center;
  }

  .select_all-btn {
    width: 140px;
    height: 40px;
    margin: 30px auto 20px;
    padding: 0;
    color: #303133;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    line-height: 40px;
    outline: none;
    border: none;
    border-radius: 6px;
    background: #FFDD02;
  }

  .cancel_all-btn {
    width: 140px;
    height: 40px;
    margin: 30px auto 20px;
    padding: 0;
    color: #303133;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    line-height: 40px;
    outline: none;
    border: none;
    border-radius: 6px;
    background: #EBEEF5;
  }
  
  .wrong-timezone {
    padding: 0;
    outline: none;
    border: none;
    background: none;
    color: #303133;

    .el-icon-question {
      margin: 0 4px;
    }
  }

  .timzone-dialog {
    .el-dialog {
      border-radius: 12px;
      background: #ffffff;
    }

    .el-dialog__header {
      padding: 20px 0 0;
    }

    .el-dialog__body {
      .tip {
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        color: #4A4A4A;
      }
    }

    .quit-btn,
    .unbinding-btn {
      border-radius: 0;
      width: 110px;
      height: 46px;
      border: none;
      border-radius: 5px;
      outline: none;
      color: #4A4A4A;
      background-color: #E4E7ED;
    }

    .unbinding-btn {
      border-radius: 5px;
      background: #FFE300;
    }
  }

  .tz-select {
    height: 34px;
    margin: 6px 0;
    padding: 4px 2px;
    border: 1px solid #696969;
    color: #4A4A4A;
    font-size: 14px;
    background: #fff;
    border-radius: 0;
    outline: none;
  }

  .tz-label {
    color: #4A4A4A;
    font-size: 12px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/h5/booking-mp.vue